import { axiosInstance } from '../../../api/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import APIEndpoints from '../../../Admin/api/APIEndpoints';

export const setUserTypes = createAsyncThunk(
  'setUserTypes',
  async (params, { getState }) => {
    const response = await axiosInstance.get(APIEndpoints.getUserTypes());
    return response;
  },
);
